export const climateMitigationActivityOptions =
[
  {
    'alias': '1.1',
    'label': 'Afforestation',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/141/view'
  },
  {
    'alias': '1.2',
    'label': 'Rehabilitation and restoration of forests, including reforestation and natural forest regeneration after an extreme event',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/142/view'
  },
  {
    'alias': '1.3',
    'label': 'Forest management',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/143/view'
  },
  {
    'alias': '1.4',
    'label': 'Conservation forestry',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/144/view'
  },
  {
    'alias': '2.1',
    'label': 'Restoration of wetlands',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/145/view'
  },
  {
    'alias': '3.1',
    'label': 'Manufacture of renewable energy technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/146/view'
  },
  {
    'alias': '3.2',
    'label': 'Manufacture of equipment for the production and use of hydrogen',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/147/view'
  },
  {
    'alias': '3.3',
    'label': 'Manufacture of low carbon technologies for transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/148/view'
  },
  {
    'alias': '3.4',
    'label': 'Manufacture of batteries',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/149/view'
  },
  {
    'alias': '3.5',
    'label': 'Manufacture of energy efficiency equipment for buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/150/view'
  },
  {
    'alias': '3.6',
    'label': 'Manufacture of other low carbon technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/151/view'
  },
  {
    'alias': '3.7',
    'label': 'Manufacture of cement',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/152/view'
  },
  {
    'alias': '3.8',
    'label': 'Manufacture of aluminium',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/153/view'
  },
  {
    'alias': '3.9',
    'label': 'Manufacture of iron and steel',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/154/view'
  },
  {
    'alias': '3.10',
    'label': 'Manufacture of hydrogen',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/155/view'
  },
  {
    'alias': '3.11',
    'label': 'Manufacture of carbon black',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/156/view'
  },
  {
    'alias': '3.12',
    'label': 'Manufacture of soda ash',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/157/view'
  },
  {
    'alias': '3.13',
    'label': 'Manufacture of chlorine',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/158/view'
  },
  {
    'alias': '3.14',
    'label': 'Manufacture of organic basic chemicals',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/159/view'
  },
  {
    'alias': '3.15',
    'label': 'Manufacture of anhydrous ammonia',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/160/view'
  },
  {
    'alias': '3.16',
    'label': 'Manufacture of nitric acid',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/161/view'
  },
  {
    'alias': '3.17',
    'label': 'Manufacture of plastics in primary form',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/162/view'
  },
  {
    'alias': '4.1',
    'label': 'Electricity generation using solar photovoltaic technology',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/163/view'
  },
  {
    'alias': '4.2',
    'label': 'Electricity generation using concentrated solar power (CSP) technology',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/164/view'
  },
  {
    'alias': '4.3',
    'label': 'Electricity generation from wind power',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/165/view'
  },
  {
    'alias': '4.4',
    'label': 'Electricity generation from ocean energy technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/166/view'
  },
  {
    'alias': '4.5',
    'label': 'Electricity generation from hydropower',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/167/view'
  },
  {
    'alias': '4.6',
    'label': 'Electricity generation from geothermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/168/view'
  },
  {
    'alias': '4.7',
    'label': 'Electricity generation from renewable non-fossil gaseous and liquid fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/169/view'
  },
  {
    'alias': '4.8',
    'label': 'Electricity generation from bioenergy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/170/view'
  },
  {
    'alias': '4.9',
    'label': 'Transmission and distribution of electricity',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/171/view'
  },
  {
    'alias': '4.10',
    'label': 'Storage of electricity',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/172/view'
  },
  {
    'alias': '4.11',
    'label': 'Storage of thermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/173/view'
  },
  {
    'alias': '4.12',
    'label': 'Storage of hydrogen',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/174/view'
  },
  {
    'alias': '4.13',
    'label': 'Manufacture of biogas and biofuels for use in transport and of bioliquids',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/175/view'
  },
  {
    'alias': '4.14',
    'label': 'Transmission and distribution networks for renewable and low-carbon gases',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/176/view'
  },
  {
    'alias': '4.15',
    'label': 'District heating/cooling distribution',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/177/view'
  },
  {
    'alias': '4.16',
    'label': 'Installation and operation of electric heat pumps',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/178/view'
  },
  {
    'alias': '4.17',
    'label': 'Cogeneration of heat/cool and power from solar energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/179/view'
  },
  {
    'alias': '4.18',
    'label': 'Cogeneration of heat/cool and power from geothermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/180/view'
  },
  {
    'alias': '4.19',
    'label': 'Cogeneration of heat/cool and power from renewable non-fossil gaseous and liquid fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/181/view'
  },
  {
    'alias': '4.20',
    'label': 'Cogeneration of heat/cool and power from bioenergy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/182/view'
  },
  {
    'alias': '4.21',
    'label': 'Production of heat/cool from solar thermal heating',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/183/view'
  },
  {
    'alias': '4.22',
    'label': 'Production of heat/cool from geothermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/184/view'
  },
  {
    'alias': '4.23',
    'label': 'Production of heat/cool from renewable non-fossil gaseous and liquid fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/185/view'
  },
  {
    'alias': '4.24',
    'label': 'Production of heat/cool from bioenergy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/186/view'
  },
  {
    'alias': '4.25',
    'label': 'Production of heat/cool using waste heat',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/187/view'
  },
  {
    'alias': '4.26',
    'label': 'Pre-commercial stages of advanced technologies to produce energy from nuclear processes with minimal waste from the fuel cycle',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/188/view'
  },
  {
    'alias': '4.27',
    'label': 'Construction and safe operation of new nuclear power plants, for the generation of electricity and/or heat, including for hydrogen production, using best-available technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/189/view'
  },
  {
    'alias': '4.28',
    'label': 'Electricity generation from nuclear energy in existing installations',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/190/view'
  },
  {
    'alias': '4.29',
    'label': 'Electricity generation from fossil gaseous fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/191/view'
  },
  {
    'alias': '4.30',
    'label': 'High-efficiency co-generation of heat/cool and power from fossil gaseous fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/192/view'
  },
  {
    'alias': '4.31',
    'label': 'Production of heat/cool from fossil gaseous fuels in an efficient district heating and cooling system',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/193/view'
  },
  {
    'alias': '5.1',
    'label': 'Construction, extension and operation of water collection, treatment and supply systems',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/194/view'
  },
  {
    'alias': '5.2',
    'label': 'Renewal of water collection, treatment and supply systems',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/195/view'
  },
  {
    'alias': '5.3',
    'label': 'Construction, extension and operation of waste water collection and treatment',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/196/view'
  },
  {
    'alias': '5.4',
    'label': 'Renewal of waste water collection and treatment',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/197/view'
  },
  {
    'alias': '5.5',
    'label': 'Collection and transport of non-hazardous waste in source segregated fractions',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/198/view'
  },
  {
    'alias': '5.6',
    'label': 'Anaerobic digestion of sewage sludge',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/199/view'
  },
  {
    'alias': '5.7',
    'label': 'Anaerobic digestion of bio-waste',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/200/view'
  },
  {
    'alias': '5.8',
    'label': 'Composting of bio-waste',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/201/view'
  },
  {
    'alias': '5.9',
    'label': 'Material recovery from non-hazardous waste',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/202/view'
  },
  {
    'alias': '5.10',
    'label': 'Landfill gas capture and utilisation',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/203/view'
  },
  {
    'alias': '5.11',
    'label': 'Transport of CO2',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/204/view'
  },
  {
    'alias': '5.12',
    'label': 'Underground permanent geological storage of CO2',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/205/view'
  },
  {
    'alias': '6.1',
    'label': 'Passenger interurban rail transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/206/view'
  },
  {
    'alias': '6.2',
    'label': 'Freight rail transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/207/view'
  },
  {
    'alias': '6.3',
    'label': 'Urban and suburban transport, road passenger transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/208/view'
  },
  {
    'alias': '6.4',
    'label': 'Operation of personal mobility devices, cycle logistics',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/209/view'
  },
  {
    'alias': '6.5',
    'label': 'Transport by motorbikes, passenger cars and light commercial vehicles',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/210/view'
  },
  {
    'alias': '6.6',
    'label': 'Freight transport services by road',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/211/view'
  },
  {
    'alias': '6.7',
    'label': 'Inland passenger water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/212/view'
  },
  {
    'alias': '6.8',
    'label': 'Inland freight water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/213/view'
  },
  {
    'alias': '6.9',
    'label': 'Retrofitting of inland water passenger and freight transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/214/view'
  },
  {
    'alias': '6.10',
    'label': 'Sea and coastal freight water transport, vessels for port operations and auxiliary activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/215/view'
  },
  {
    'alias': '6.11',
    'label': 'Sea and coastal passenger water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/216/view'
  },
  {
    'alias': '6.12',
    'label': 'Retrofitting of sea and coastal freight and passenger water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/217/view'
  },
  {
    'alias': '6.13',
    'label': 'Infrastructure for personal mobility, cycle logistics',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/218/view'
  },
  {
    'alias': '6.14',
    'label': 'Infrastructure for rail transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/219/view'
  },
  {
    'alias': '6.15',
    'label': 'Infrastructure enabling low-carbon road transport and public transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/220/view'
  },
  {
    'alias': '6.16',
    'label': 'Infrastructure enabling low carbon water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/221/view'
  },
  {
    'alias': '6.17',
    'label': 'Low carbon airport infrastructure',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/222/view'
  },
  {
    'alias': '7.1',
    'label': 'Construction of new buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/223/view'
  },
  {
    'alias': '7.2',
    'label': 'Renovation of existing buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/224/view'
  },
  {
    'alias': '7.3',
    'label': 'Installation, maintenance and repair of energy efficiency equipment',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/225/view'
  },
  {
    'alias': '7.4',
    'label': 'Installation, maintenance and repair of charging stations for electric vehicles in buildings (and parking spaces attached to buildings)',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/226/view'
  },
  {
    'alias': '7.5',
    'label': 'Installation, maintenance and repair of instruments and devices for measuring, regulation and controlling energy performance of buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/227/view'
  },
  {
    'alias': '7.6',
    'label': 'Installation, maintenance and repair of renewable energy technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/228/view'
  },
  {
    'alias': '7.7',
    'label': 'Acquisition and ownership of buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/229/view'
  },
  {
    'alias': '8.1',
    'label': 'Data processing, hosting and related activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/230/view'
  },
  {
    'alias': '8.2',
    'label': 'Data-driven solutions for GHG emissions reductions',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/231/view'
  },
  {
    'alias': '9.1',
    'label': 'Close to market research, development and innovation',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/232/view'
  },
  {
    'alias': '9.2',
    'label': 'Research, development and innovation for direct air capture of CO2',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/233/view'
  },
  {
    'alias': '9.3',
    'label': 'Professional services related to energy performance of buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/234/view'
  }
];

export const climateAdaptationOptions =
[
  {
    'alias': '1.1',
    'label': 'Afforestation',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/141/view'
  },
  {
    'alias': '1.2',
    'label': 'Rehabilitation and restoration of forests, including reforestation and natural forest regeneration after an extreme event',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/142/view'
  },
  {
    'alias': '1.3',
    'label': 'Forest management',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/143/view'
  },
  {
    'alias': '1.4',
    'label': 'Conservation forestry',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/144/view'
  },
  {
    'alias': '2.1',
    'label': 'Restoration of wetlands',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/145/view'
  },
  {
    'alias': '3.1',
    'label': 'Manufacture of renewable energy technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/146/view'
  },
  {
    'alias': '3.2',
    'label': 'Manufacture of equipment for the production and use of hydrogen',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/147/view'
  },
  {
    'alias': '3.3',
    'label': 'Manufacture of low carbon technologies for transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/148/view'
  },
  {
    'alias': '3.4',
    'label': 'Manufacture of batteries',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/149/view'
  },
  {
    'alias': '3.5',
    'label': 'Manufacture of energy efficiency equipment for buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/150/view'
  },
  {
    'alias': '3.6',
    'label': 'Manufacture of other low carbon technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/151/view'
  },
  {
    'alias': '3.7',
    'label': 'Manufacture of cement',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/152/view'
  },
  {
    'alias': '3.8',
    'label': 'Manufacture of aluminium',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/153/view'
  },
  {
    'alias': '3.9',
    'label': 'Manufacture of iron and steel',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/154/view'
  },
  {
    'alias': '3.10',
    'label': 'Manufacture of hydrogen',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/155/view'
  },
  {
    'alias': '3.11',
    'label': 'Manufacture of carbon black',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/156/view'
  },
  {
    'alias': '3.12',
    'label': 'Manufacture of soda ash',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/157/view'
  },
  {
    'alias': '3.13',
    'label': 'Manufacture of chlorine',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/158/view'
  },
  {
    'alias': '3.14',
    'label': 'Manufacture of organic basic chemicals',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/159/view'
  },
  {
    'alias': '3.15',
    'label': 'Manufacture of anhydrous ammonia',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/160/view'
  },
  {
    'alias': '3.16',
    'label': 'Manufacture of nitric acid',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/161/view'
  },
  {
    'alias': '3.17',
    'label': 'Manufacture of plastics in primary form',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/162/view'
  },
  {
    'alias': '4.1',
    'label': 'Electricity generation using solar photovoltaic technology',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/163/view'
  },
  {
    'alias': '4.2',
    'label': 'Electricity generation using concentrated solar power (CSP) technology',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/164/view'
  },
  {
    'alias': '4.3',
    'label': 'Electricity generation from wind power',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/165/view'
  },
  {
    'alias': '4.4',
    'label': 'Electricity generation from ocean energy technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/166/view'
  },
  {
    'alias': '4.5',
    'label': 'Electricity generation from hydropower',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/167/view'
  },
  {
    'alias': '4.6',
    'label': 'Electricity generation from geothermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/168/view'
  },
  {
    'alias': '4.7',
    'label': 'Electricity generation from renewable non-fossil gaseous and liquid fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/169/view'
  },
  {
    'alias': '4.8',
    'label': 'Electricity generation from bioenergy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/170/view'
  },
  {
    'alias': '4.9',
    'label': 'Transmission and distribution of electricity',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/171/view'
  },
  {
    'alias': '4.10',
    'label': 'Storage of electricity',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/172/view'
  },
  {
    'alias': '4.11',
    'label': 'Storage of thermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/173/view'
  },
  {
    'alias': '4.12',
    'label': 'Storage of hydrogen',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/174/view'
  },
  {
    'alias': '4.13',
    'label': 'Manufacture of biogas and biofuels for use in transport and of bioliquids',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/175/view'
  },
  {
    'alias': '4.14',
    'label': 'Transmission and distribution networks for renewable and low-carbon gases',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/176/view'
  },
  {
    'alias': '4.15',
    'label': 'District heating/cooling distribution',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/177/view'
  },
  {
    'alias': '4.16',
    'label': 'Installation and operation of electric heat pumps',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/178/view'
  },
  {
    'alias': '4.17',
    'label': 'Cogeneration of heat/cool and power from solar energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/179/view'
  },
  {
    'alias': '4.18',
    'label': 'Cogeneration of heat/cool and power from geothermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/180/view'
  },
  {
    'alias': '4.19',
    'label': 'Cogeneration of heat/cool and power from renewable non-fossil gaseous and liquid fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/181/view'
  },
  {
    'alias': '4.20',
    'label': 'Cogeneration of heat/cool and power from bioenergy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/182/view'
  },
  {
    'alias': '4.21',
    'label': 'Production of heat/cool from solar thermal heating',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/183/view'
  },
  {
    'alias': '4.22',
    'label': 'Production of heat/cool from geothermal energy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/184/view'
  },
  {
    'alias': '4.23',
    'label': 'Production of heat/cool from renewable non-fossil gaseous and liquid fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/185/view'
  },
  {
    'alias': '4.24',
    'label': 'Production of heat/cool from bioenergy',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/186/view'
  },
  {
    'alias': '4.25',
    'label': 'Production of heat/cool using waste heat',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/187/view'
  },
  {
    'alias': '4.26',
    'label': 'Pre-commercial stages of advanced technologies to produce energy from nuclear processes with minimal waste from the fuel cycle',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/188/view'
  },
  {
    'alias': '4.27',
    'label': 'Construction and safe operation of new nuclear power plants, for the generation of electricity and/or heat, including for hydrogen production, using best-available technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/189/view'
  },
  {
    'alias': '4.28',
    'label': 'Electricity generation from nuclear energy in existing installations',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/190/view'
  },
  {
    'alias': '4.29',
    'label': 'Electricity generation from fossil gaseous fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/191/view'
  },
  {
    'alias': '4.30',
    'label': 'High-efficiency co-generation of heat/cool and power from fossil gaseous fuels',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/192/view'
  },
  {
    'alias': '4.31',
    'label': 'Production of heat/cool from fossil gaseous fuels in an efficient district heating and cooling system',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/193/view'
  },
  {
    'alias': '5.1',
    'label': 'Construction, extension and operation of water collection, treatment and supply systems',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/194/view'
  },
  {
    'alias': '5.2',
    'label': 'Renewal of water collection, treatment and supply systems',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/195/view'
  },
  {
    'alias': '5.3',
    'label': 'Construction, extension and operation of waste water collection and treatment',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/196/view'
  },
  {
    'alias': '5.4',
    'label': 'Renewal of waste water collection and treatment',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/197/view'
  },
  {
    'alias': '5.5',
    'label': 'Collection and transport of non-hazardous waste in source segregated fractions',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/198/view'
  },
  {
    'alias': '5.6',
    'label': 'Anaerobic digestion of sewage sludge',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/199/view'
  },
  {
    'alias': '5.7',
    'label': 'Anaerobic digestion of bio-waste',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/200/view'
  },
  {
    'alias': '5.8',
    'label': 'Composting of bio-waste',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/201/view'
  },
  {
    'alias': '5.9',
    'label': 'Material recovery from non-hazardous waste',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/202/view'
  },
  {
    'alias': '5.10',
    'label': 'Landfill gas capture and utilisation',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/203/view'
  },
  {
    'alias': '5.11',
    'label': 'Transport of CO2',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/204/view'
  },
  {
    'alias': '5.12',
    'label': 'Underground permanent geological storage of CO2',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/205/view'
  },
  {
    'alias': '6.1',
    'label': 'Passenger interurban rail transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/206/view'
  },
  {
    'alias': '6.2',
    'label': 'Freight rail transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/207/view'
  },
  {
    'alias': '6.3',
    'label': 'Urban and suburban transport, road passenger transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/208/view'
  },
  {
    'alias': '6.4',
    'label': 'Operation of personal mobility devices, cycle logistics',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/209/view'
  },
  {
    'alias': '6.5',
    'label': 'Transport by motorbikes, passenger cars and light commercial vehicles',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/210/view'
  },
  {
    'alias': '6.6',
    'label': 'Freight transport services by road',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/211/view'
  },
  {
    'alias': '6.7',
    'label': 'Inland passenger water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/212/view'
  },
  {
    'alias': '6.8',
    'label': 'Inland freight water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/213/view'
  },
  {
    'alias': '6.9',
    'label': 'Retrofitting of inland water passenger and freight transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/214/view'
  },
  {
    'alias': '6.10',
    'label': 'Sea and coastal freight water transport, vessels for port operations and auxiliary activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/215/view'
  },
  {
    'alias': '6.11',
    'label': 'Sea and coastal passenger water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/216/view'
  },
  {
    'alias': '6.12',
    'label': 'Retrofitting of sea and coastal freight and passenger water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/217/view'
  },
  {
    'alias': '6.13',
    'label': 'Infrastructure for personal mobility, cycle logistics',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/218/view'
  },
  {
    'alias': '6.14',
    'label': 'Infrastructure for rail transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/219/view'
  },
  {
    'alias': '7.1',
    'label': 'Construction of new buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/223/view'
  },
  {
    'alias': '7.2',
    'label': 'Renovation of existing buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/224/view'
  },
  {
    'alias': '7.3',
    'label': 'Installation, maintenance and repair of energy efficiency equipment',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/225/view'
  },
  {
    'alias': '7.4',
    'label': 'Installation, maintenance and repair of charging stations for electric vehicles in buildings (and parking spaces attached to buildings)',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/226/view'
  },
  {
    'alias': '7.5',
    'label': 'Installation, maintenance and repair of instruments and devices for measuring, regulation and controlling energy performance of buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/227/view'
  },
  {
    'alias': '7.6',
    'label': 'Installation, maintenance and repair of renewable energy technologies',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/228/view'
  },
  {
    'alias': '7.7',
    'label': 'Acquisition and ownership of buildings',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/229/view'
  },
  {
    'alias': '8.1',
    'label': 'Data processing, hosting and related activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/230/view'
  },
  {
    'alias': '9.2',
    'label': 'Close to market research, development and innovation',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/232/view'
  },
  {
    'alias': '6.15',
    'label': 'Infrastructure enabling road transport and public transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/235/view'
  },
  {
    'alias': '6.16',
    'label': 'Infrastructure for water transport',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/236/view'
  },
  {
    'alias': '6.17',
    'label': 'Airport infrastructure',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/237/view'
  },
  {
    'alias': '8.2',
    'label': 'Computer programming, consultancy and related activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/238/view'
  },
  {
    'alias': '8.3',
    'label': 'Programming and broadcasting activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/239/view'
  },
  {
    'alias': '9.1',
    'label': 'Engineering activities and related technical consultancy dedicated to adaptation to climate change',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/240/view'
  },
  {
    'alias': '10.1',
    'label': 'Non-life insurance: underwriting of climate-related perils',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/241/view'
  },
  {
    'alias': '10.2',
    'label': 'Reinsurance',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/242/view'
  },
  {
    'alias': '11.1',
    'label': 'Education',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/243/view'
  },
  {
    'alias': '12.1',
    'label': 'Residential care activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/244/view'
  },
  {
    'alias': '13.1',
    'label': 'Creative, arts and entertainment activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/245/view'
  },
  {
    'alias': '13.2',
    'label': 'Libraries, archives, museums and cultural activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/246/view'
  },
  {
    'alias': '13.3',
    'label': 'Motion picture, video and television programme production, sound recording and music publishing activities',
    'reference': 'https://ec.europa.eu/sustainable-finance-taxonomy/activities/activity/247/view'
  }
];
